
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.914 7.969c0-.953-.25-2.172-.75-3.657-.5-1.484-.89-2.39-1.172-2.718-.281-.328-.55-.492-.804-.492-.329 0-.641.138-.938.414l-.367-.493c.422-.338.76-.557 1.015-.656.256-.104.56-.156.915-.156.458 0 .843.125 1.156.375.317.25.627.786.93 1.61.307.822.609 2.057.906 3.702h.11c.197-.875.504-1.862.92-2.96.418-1.1.837-1.829 1.259-2.188.427-.36.909-.54 1.445-.54.287 0 .57.06.852.18v1.438H9.68c-.115-.26-.29-.39-.524-.39-.302 0-.596.182-.883.546-.28.365-.669 1.209-1.164 2.532-.49 1.317-.734 2.468-.734 3.453v1.054c0 .526.057.901.172 1.125.114.224.409.38.883.47V11H3.86v-.383c.489-.104.786-.268.89-.492.11-.23.164-.596.164-1.102V7.97z","fill":"currentColor"}})])
          )
        }
      }
    